import {
    Form,
    Input,
    Button,
    Select,
    Result,
    InputNumber,
} from "antd";
import { useState } from "react";
import { useForm } from "antd/lib/form/Form";
import {
    signularisApi,
    useCreateMetaDocumentMutation,
    useGetRecipientsListQuery
} from "../../../store/api/signularisApi";
import { useSelector } from "react-redux";
import genDocument10 from '../misc/gendoc10';
import { RootState } from "../../../store/store";
import { useAppDispatch } from "../../../hooks/redux";
import { CREATE_DOCUMENT_ROUTE, MAIN_PAGE_ROUTE } from "../../../routing/consts";
import { Link } from "react-router-dom";
import { DocTemplateType } from "../../../types/types";
import { documentTemplates } from "../../../const";
import { MinusCircleOutlined, PlusOutlined, SendOutlined } from "@ant-design/icons";
import style from '../CreateDocument.module.scss';

const { Item } = Form;
const { TextArea } = Input;
const { Option } = Select;

// Генерирует ID
let guid = () => {
    let s4 = () => Math.floor((1 + Math.random()) * 0x100).toString(10).substring(1);
    return s4() + s4() + s4() + s4();
}

// Форматирование даты
function styledDate() {
    const months = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля",
        "августа", "сентября", "октября", "ноября", "декабря"]
    const dobj = new Date()
    return `${dobj.getDate()} ${months[dobj.getMonth()]} ${dobj.getFullYear()}`
}

function Template() {
    const info = useSelector((state: RootState) => state.userinfo)
    const dispatch = useAppDispatch()
    const { data: recipients } = useGetRecipientsListQuery()
    const [form] = useForm()
    
    // Следим за изменениями в списке для автоматического расчета сумм
    const truValues = Form.useWatch('tru', form);

    const defaulRepicients = ["62567bcc72944c7123ebde5a", '62303f756315cc23e79ca2c9']
    const recipientsList = recipients?.filter(item => !defaulRepicients.includes(item.id)) || []

    const [docname, setDocname] = useState("")
    const docTemplate: DocTemplateType = 'acceptanceCertificate'

    const [createMetaDocument, {
        isLoading: mutationLoading,
        isSuccess: mutationSuccess,
    }] = useCreateMetaDocumentMutation()

    const onFinish = async (values: any) => {
        const regnum = guid()
        const templateName = documentTemplates.acceptanceCertificate;
        setDocname(templateName)

        const formData = new FormData()
        formData.append("title", `${templateName} №${regnum}`)
        formData.append("brief", "Сгенерировано из шаблона")
        formData.append("recipients", (values.recipients || []).join(",") + ',' + defaulRepicients.join(","))
        formData.append("documentType", docTemplate)
        
        const templateValues = {
            ...values,
            regnum,
            regdate: styledDate(),
            dutyface: `${info.lastname} ${info.firstname} ${info.middlename}`,
            docTitle: 'Проректору по АХЧ \nЧегарбиеву А.С.' // Хардкод из оригинала
        }

        const pdfBytes = await genDocument10(templateValues, info)
        formData.append("file", new Blob([pdfBytes]))
        
        createMetaDocument(formData)
        dispatch(signularisApi.util.invalidateTags(['MetaDocument']))
    }

    if (mutationSuccess) return (
        <Result
            status="success"
            title="Акт создан"
            subTitle={`Ваш документ успешно сформирован и отправлен.`}
            extra={<Link to={MAIN_PAGE_ROUTE + '/' + CREATE_DOCUMENT_ROUTE}><Button type="primary">Создать еще</Button></Link>}
        />
    );

    return (
        <div className={style.generatorWrapper}>
            <h2 className={style.title}>{documentTemplates.acceptanceCertificate}</h2>
            
            <Form 
                form={form} 
                onFinish={onFinish} 
                layout="vertical"
                initialValues={{regtext: "Мы нижеподписавшиеся составили настоящий акт о том, что  ____(должность и ФИО)____  сдал, а  ____(должность и ФИО)____  принял нижеперечисленные материальные ценности (Приложение 1)"}}
            >
                <Item label="Получатели" name="recipients">
                    <Select
                        mode="multiple"
                        placeholder="Выберите дополнительных сотрудников..."
                        size="large"
                        allowClear
           filterOption={(input, option) =>
              (option?.label as string ?? '').toLowerCase().includes(input.toLowerCase())
            }
                    >
                        {recipientsList?.map((recipient) => (
                                <Option key={recipient.id} value={recipient.id} label={recipient.fullname}>
                                {recipient.fullname} {!!recipient.position && <>- <span style={{color: 'gray', fontSize: 12}}>{recipient.position}</span></>}
                                </Option>
                            ))}
                    </Select>
                </Item>

                <div className={style.recipientTags}>
                    <span className={style.tag}>Магомедов Тимур Эейсаевич</span>
                    <span className={style.tag}>Чегарбиев Адлан Сулейманович</span>
                </div>

                <Item label="Текст акта" name="regtext" rules={[{required: true, message: 'Заполните вводную часть'}]}>
                    <TextArea rows={4} placeholder="Введите данные передающей и принимающей сторон..."/>
                </Item>

                <div className={style.sectionTitle} style={{ marginTop: 32 }}>Приложение 1: Материальные ценности</div>
                
                <div className={style.dynamicList}>
                    <Form.List name="tru">
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map(({ key, name, ...restField }, index) => (
                                    <div key={key} style={{ background: '#fff', padding: '20px', borderRadius: '16px', border: '1px solid #e2e8f0', marginBottom: '16px', position: 'relative' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16, alignItems: 'center' }}>
                                            <span className={style.tag}>Позиция №{index + 1}</span>
                                            <Button type="text" danger onClick={() => remove(name)} icon={<MinusCircleOutlined />} />
                                        </div>
                                        
                                        <Item {...restField} name={[name, 'name']} label="Наименование" rules={[{ required: true }]}>
                                            <Input placeholder="Напр: Монитор Samsung" />
                                        </Item>

                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                            <Item {...restField} name={[name, 'num']} label="Инвентарный №" rules={[{ required: true }]}>
                                                <Input placeholder="00000000" />
                                            </Item>
                                            <Item {...restField} name={[name, 'edIzmereniya']} label="Ед. изм." initialValue="шт.">
                                                <Input disabled />
                                            </Item>
                                        </div>

                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', alignItems: 'flex-end' }}>
                                            <Item {...restField} name={[name, 'count']} label="Количество" rules={[{ required: true }]}>
                                                <InputNumber placeholder="0" />
                                            </Item>
                                            <Item {...restField} name={[name, 'price']} label="Цена (руб)" rules={[{ required: true }]}>
                                                <InputNumber placeholder="0.00" />
                                            </Item>
                                            <div style={{ marginBottom: '24px' }}>
                                                <div style={{ fontSize: '11px', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', marginBottom: '8px' }}>Сумма</div>
                                                <div style={{ height: '44px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', display: 'flex', alignItems: 'center', padding: '0 12px', fontWeight: 700, color: '#212d3a' }}>
                                                    { (truValues?.[index]?.count && truValues?.[index]?.price) 
                                                        ? (truValues[index].count * truValues[index].price).toLocaleString() + ' ₽' 
                                                        : '—' 
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <Button 
                                    type="dashed" 
                                    onClick={() => add()} 
                                    block 
                                    icon={<PlusOutlined />}
                                    style={{ height: '50px', borderRadius: '12px' }}
                                >
                                    Добавить ценность
                                </Button>
                            </>
                        )}
                    </Form.List>
                </div>

                <Button 
                    type="primary" 
                    htmlType="submit" 
                    loading={mutationLoading}
                    size="large"
                    icon={<SendOutlined style={{ display: 'inline-flex' }} />}
                    style={{ width: '100%', marginTop: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                    Сформировать акт
                </Button>
            </Form>
        </div>
    )
}

export default Template;
